import { SmallBtn } from './buttons'
import SaveBtnSm from '@/components/common/btn/SaveBtnSm'
import SaveBtn from '@/components/common/btn/SaveBtn'
import AddBtnSm from '@/components/common/btn/AddBtnSm'
import BackBtnSm from '@/components/common/btn/BackBtnSm'
import DeleteBtnSm from '@/components/common/btn/DeleteBtnSm'
import DeleteBtnXs from '@/components/common/btn/DeleteBtnXs'
import EditBtnSm from '@/components/common/btn/EditBtnSm'
import ListBtnSm from '@/components/common/btn/ListBtnSm'
import CancelBtnSm from '@/components/common/btn/CancelBtnSm'
import DatePicker from '@/components/common/DatePicker'
import DatePicker2 from '@/components/common/DatePicker2'
import LabelSelect from '@/components/common/LabelSelect'
import ModalDlg from '@/components/common/ModalDlg'
import MessageBox from '@/components/common/MessageBox'

import { mdbIcon, mdbBtn, mdbInput, mdbRow, mdbCol, mdbBadge, mdbBtnGroup, mdbTbl, mdbTblHead, mdbTblBody, mdbFormInline, mdbToastNotification } from 'mdbvue';
export default {
  install (Vue) {
    Vue.component('mdbIcon', mdbIcon);
    Vue.component('mdbBtn', mdbBtn);
    Vue.component('mdbBtnGroup', mdbBtnGroup);
    Vue.component('mdbFormInline', mdbFormInline);
    Vue.component('mdbInput', mdbInput);
    Vue.component('mdbRow', mdbRow);
    Vue.component('mdbCol', mdbCol);
    Vue.component('mdbBadge', mdbBadge);
    Vue.component('mdbTbl', mdbTbl);
    Vue.component('mdbTblHead', mdbTblHead);
    Vue.component('mdbTblBody', mdbTblBody);
    Vue.component('SmallBtn', SmallBtn);
    Vue.component('AddBtnSm', AddBtnSm);
    Vue.component('BackBtnSm', BackBtnSm);
    Vue.component('SaveBtnSm', SaveBtnSm);
    Vue.component('SaveBtn', SaveBtn);
    Vue.component('DeleteBtnSm', DeleteBtnSm);
    Vue.component('DeleteBtnXs', DeleteBtnXs);
    Vue.component('EditBtnSm', EditBtnSm);
    Vue.component('ListBtnSm', ListBtnSm);
    Vue.component('DatePicker', DatePicker);
    Vue.component('CancelBtnSm', CancelBtnSm);
    Vue.component('DatePicker2', DatePicker2);
    Vue.component('LabelSelect', LabelSelect);
    Vue.component('mdbToastNotification', mdbToastNotification);
    Vue.component('MessageBox', MessageBox);
    Vue.component('ModalDlg', ModalDlg);
    Vue.component('Title', {
      name: 'Title',
      template: '<div class="title"><slot/></div>'
    });
    Vue.component('PageTitle', {
      name: 'PageTitle',
      template: '<div class="page-title"><slot/></div>'
    });
  }
}
